import { SelectedActions } from './selectedStudents';

interface IActionsProps {
  selectedRows: unknown[];
}

/**
 * Currently not generalised for use on admissions dashboard, selected row actions are specific for
 * the cas workflow dashboard.
 *
 * @deprecated (needs to be replaced)!!!
 **/
export const ActionToolbar = (props: IActionsProps) => {
  const { selectedRows } = props;

  const studentSelected = Object.keys(selectedRows).length > 0;

  if (studentSelected) {
    return <SelectedActions />;
  }
};
